export const getUpdatedFeatureFlags = (featureFlags, featureFlagsTracking) => {
    // TODO: keeping this logic in order to pass other a/b test parameters to the BFF (ASC-3898)
    return { featureFlags, featureFlagsTracking };
};
